module.exports = __webpack_public_path__ + "img/dep_personalcare.f38bad66.png";